/**
 * Breadcrumb — DS Molecule
 */

import styles from './Breadcrumb.module.css';

interface BreadcrumbItem {
  label: string;
  href?: string;
  onClick?: () => void;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
  className?: string;
}

export function Breadcrumb({ items, className = '' }: BreadcrumbProps) {
  return (
    <nav aria-label="Fil d'ariane" className={className}>
      <ol className={styles.list}>
        {items.map((item, i) => {
          const isLast = i === items.length - 1;
          return (
            <li key={i} className={`${styles.item} ${isLast ? styles.active : ''}`}>
              {!isLast && (item.href || item.onClick) ? (
                <a href={item.href} onClick={item.onClick} className={styles.link}>{item.label}</a>
              ) : (
                <span>{item.label}</span>
              )}
              {!isLast && <i className={`bi bi-chevron-right ${styles.sep}`} />}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
